<template>
  <div class="white-bg">
    <div class="login-bottom main_content">
      <div class="login-bottom-list mc-size16 mc-flex mc-items-center mc-flex-justify-center">
        <router-link to="/home" class="yellow-hover">首页</router-link>
        <span class="line"></span>
        <router-link to="/search?type=spot" class="yellow-hover">现货专区</router-link>
        <span class="line"></span>
        <!-- <router-link to="/inquiry" class="yellow-hover">我要咨询</router-link> -->
        <span class="line"></span>
        <router-link to="/brand" class="yellow-hover">品牌馆</router-link>
        <span class="line"></span>
        <router-link to="/solution" class="yellow-hover">解决方案</router-link>
        <span class="line"></span>
        <!-- <router-link to="/cooperate" class="yellow-hover">我要合作</router-link> -->
        
      </div>
      <div
        class="copy-right mc-size16 gray9-text mc-text-center mc-mt-20"
      >{{company.copyRight}}</div>
    </div>
  </div>
</template>

<script>

import {mapState} from 'vuex'
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState({
      company: 'company'
    })
  },

  // components: {},

  // computed: {},

  // mounted: {},

  // methods: {}
};
</script>
<style lang='less' scoped>
@import "~@/assets/css/less.less";
.login-bottom {
  padding: 30px 0;
  .login-bottom-list {
    a {
      color: @gray9;
    }
    .line {
      margin: 0 8px;
      height: 16px;
      border: 1px solid @ccc;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LoginBottom.vue